var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMale = function SvgMale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20.2 9.4c0-.57-.12-1.11-.335-1.6H19.8a3.2 3.2 0 0 1-2.52-1.225A4 4 0 0 1 13.8 8.6h-1.52c-.05.26-.08.525-.08.8v.8c0 2.21 1.79 4 4 4s4-1.79 4-4zm-10.4 0A6.4 6.4 0 0 1 16.2 3a6.4 6.4 0 0 1 6.4 6.4v.8a6.4 6.4 0 0 1-6.4 6.4 6.4 6.4 0 0 1-6.4-6.4zM7.415 26.2H24.99a6 6 0 0 0-3.72-5.155l-2.51 3.345a3.202 3.202 0 0 1-5.12 0l-2.51-3.345A6 6 0 0 0 7.415 26.2m4.19-7.81c.29-.065.585.06.765.295l3.195 4.26c.32.425.96.425 1.28 0l3.195-4.26a.76.76 0 0 1 .765-.295A8.41 8.41 0 0 1 27.4 26.6v.4c0 .885-.715 1.6-1.6 1.6H6.6c-.885 0-1.6-.715-1.6-1.6v-.4c0-4.025 2.83-7.385 6.605-8.21"
  })));
};
export default SvgMale;